<template>
  <el-card>
    <!-- 表单 -->
    <div class="header-form">
      <el-form
        :inline="true"
        ref="searchForm"
        :model="searchForm"
        class="demo-form-inline"
        @keyup.enter.native="searchList"
        @submit.native.prevent
      >
        <el-form-item label="模块" prop="modules">
          <el-select v-model="searchForm.modules" placeholder="请选择" @change="searchList">
            <el-option label="全部" value="" />
            <el-option
              v-for="item in modulesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="searchForm.type" placeholder="请选择" @change="searchList">
            <el-option label="全部" value="" />
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="操作内容" prop="desc">
          <el-input
            v-model="searchForm.desc"
            clearable
            placeholder="请输入操作内容"
            @clear="searchList"
          />
        </el-form-item>
        <el-form-item label="操作人" prop="oprator_name">
          <el-autocomplete
            v-model="searchForm.oprator_name"
            :fetch-suggestions="querySearchAsync"
            clearable
            placeholder="请搜索操作人"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="操作时间" prop="create_time">
          <el-date-picker
            v-model="searchForm.create_time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchList">搜索</el-button>
          <el-button @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 列表 -->
    <el-table :data="list" v-loading="loading">
      <el-table-column prop="id" label="ID" />
      <el-table-column label="模块" min-width="50">
        <template slot-scope="scope">
          {{ getModulesValue(modulesValue, scope.row.modules) }}
        </template>
      </el-table-column>
      <el-table-column label="类型" min-width="60">
        <template slot-scope="scope">
          {{ getTypeValue(typeValue, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="操作内容" min-width="200" />
      <el-table-column prop="difference_data" label="差异" min-width="150">
        <template slot-scope="scope">
          <span v-if="getValue(scope.row.difference_data).length < 41">
            {{ getValue(scope.row.difference_data) }}
          </span>
          <el-tooltip
            v-else
            effect="dark"
            :content="getValue(scope.row.difference_data)"
            placement="top-start"
          >
            <span>{{ getValue(scope.row.difference_data).slice(0, 40) }}...</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="oprator_name" label="操作人" min-width="50" />
      <el-table-column label="操作时间">
        <template #default="scope">
          {{ formatDate(scope.row.create_time) }}
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="searchForm.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />
  </el-card>
</template>

<script>
import { calVariables, request, whereGql } from '@/graphql/util';
import dayjs from 'dayjs';
export default {
  components: {},
  data() {
    return {
      // 表单
      searchForm: {
        desc: '',
        modules: '',
        type: '',
        oprator_name: '',
        create_time: '',
        page: 1,
        size: 10,
      },
      // 表格
      loading: false,
      list: [{ status: 'Active' }],
      // 选项数据
      object: {},
      total: 0,
      detail: {},
      userList: [],
      timeout: null,
    };
  },
  computed: {
    typeOptions() {
      if (!this.object.fields) {
        return [];
      }
      const { options } = this.object.fields.find((item) => {
        return item.name === 'type';
      }).select_one_option;
      return options;
    },
    typeValue() {
      const obj = {};
      this.typeOptions.forEach((item) => {
        obj[item.value] = item;
      });
      return obj;
    },
    modulesOptions() {
      if (!this.object.fields) {
        return [];
      }
      const { options } = this.object.fields.find((item) => {
        return item.name === 'modules';
      }).select_one_option;
      return options;
    },
    modulesValue() {
      const obj = {};
      this.modulesOptions.forEach((item) => {
        obj[item.value] = item;
      });
      return obj;
    },
  },
  created() {
    this.getList();
    this.getObject();
  },
  methods: {
    searchList() {
      this.searchForm.page = 0;
      this.getList();
    },
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.searchList();
    },
    async getList() {
      this.loading = true;
      const getRecordingGql = `query{$tableName (_limit:$limit,_offset:$offset,$filter,_order_by: {create_time: _desc, id:_desc}) {_aggregate{_count}_all}} `;
      try {
        let filterArr = [];
        const { size, page } = this.searchForm;
        if (this.searchForm.desc) {
          filterArr = [
            {
              whereGqlType: 'like',
              desc: `%${this.searchForm.desc}%`,
            },
          ];
        }
        if (this.searchForm.type) {
          filterArr.push({
            whereGqlType: 'like',
            type: `%${this.searchForm.type}%`,
          });
        }
        if (this.searchForm.modules) {
          filterArr.push({
            whereGqlType: 'like',
            modules: `%${this.searchForm.modules}%`,
          });
        }
        if (this.searchForm.oprator_name) {
          filterArr.push({
            whereGqlType: 'like',
            oprator_name: `%${this.searchForm.oprator_name}%`,
          });
        }
        if (this.searchForm.create_time) {
          const startDate = new Date(this.searchForm.create_time[0]);
          const endDate = new Date(this.searchForm.create_time[1]);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          filterArr.push(
            {
              whereGqlType: 'min',
              create_time: Math.floor(startDate.getTime() / 1000),
            },
            {
              whereGqlType: 'max',
              create_time: Math.floor(endDate.getTime() / 1000),
            },
          );
        }
        const data = {
          limit: size,
          offset: size * (page - 1),
          tableName: 'conf_audit_log',
          filter: whereGql(filterArr),
        };
        const result = await request(
          '/api/access/pb/cmd/DataAdminServer/MetadataOtherInfo/QueryWithCheck',
          {
            query: calVariables(getRecordingGql, data),
          },
        );
        this.list = result.conf_audit_log._data;
        this.total = result.conf_audit_log._aggregate.count;
        this.loading = false;
      } catch (err) {
        console.log('getList err:', err);
        this.list = [];
        this.total = 0;
        this.loading = false;
      }
    },
    async getObject() {
      try {
        const { list } = await this.$request({
          url: '/api/access/pb/cmd/DataServer/MetadataService/GetObjectsByNames',
          data: {
            objects: ['conf_audit_log'],
          },
        });
        this.object = list[0];
      } catch (err) {
        console.log(err);
      }
    },

    // 分页器
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.searchForm.size = val;
      this.searchForm.page = 1;
      this.getList();
    },
    // 时间格式化
    formatDate(val) {
      if (!val) return '-';
      return dayjs(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
    // 筛选
    filterModules(value, row) {
      return row.modules === value;
    },
    filterType(value, row) {
      return row.type === value;
    },
    getTypeValue(list, val) {
      list = Object.values(list);
      return list.find(({ value }) => value === val)?.label || val;
    },
    getModulesValue(list, val) {
      list = Object.values(list);
      return list.find(({ value }) => value === val)?.label || val;
    },
    getValue(val) {
      if (val === null) {
        return '';
      }
      switch (typeof val) {
        case 'string':
          return `${val}`;
        case 'boolean':
          return val ? 'true' : 'false';
        case 'number':
          return `${val}`;
        case 'undefined':
          return '';
        default:
          return JSON.stringify(val);
      }
    },
    querySearchAsync(queryString, cb) {
      const url = '/api/access/pb/cmd/AuthAdminServer/AuthAdminUser/GetUserList';
      const data = {
        keyword: queryString,
        page: 1,
        type: 1,
        page_size: 10,
      };
      this.$request({ url, data }).then((data) => {
        this.userList = data.data.map((i) => {
          return {
            label: i.account,
            value: i.name,
          };
        });
      });
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const results = this.userList;
        cb(results);
      }, 3000 * Math.random());
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/table.scss';

::v-deep .el-select {
  width: 100%;
}
::v-deep .el-date-editor .el-range-separator {
  padding: 0px;
}

.header-form {
  display: flex;
  justify-content: space-between;

  .header-form-button {
    height: 40px;
  }
}
</style>
